export default __webpack_public_path__ + "assets/images/59125d5e5e1747aac21f61d75999b305.svg";